/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { CaseData, CaseStatus } from '../../data/types';

export type CaseDataState = {
    caseData?: CaseData,
}

export const useCaseDataState = () => {
    const caseDataState = useSelector((state: RootState | any) => state.caseData as CaseDataState);
    return caseDataState;
}

// Define the initial state using that type
const initialState: CaseDataState = {
    caseData: {
        expenseTypes: [] as string[],
        statuses: [] as CaseStatus[],
        types: [] as string[],
    } as CaseData,
}

export const caseDataSlice = createSlice({
    name: 'caseData',
    initialState,
    reducers: {
        setCaseDataAction: (state, action: PayloadAction<CaseData>) => {
            state.caseData = action.payload;
        },
        setCaseStatusesAction: (state, action: PayloadAction<CaseStatus[]>) => {
            state.caseData!.statuses = action.payload;
        },
        addTypeAction: (state, action: PayloadAction<string>) => {
            if (state.caseData) {
                if (!state.caseData.types) {
                    state.caseData.types = [];
                }
                // The signalR upsert can already contain the new type, so guard against duplicates
                if (!state.caseData.types.includes(action.payload)) {
                    state.caseData.types.push(action.payload);
                }
            }
        },
        addStatusAction: (state, action: PayloadAction<CaseStatus>) => {
            if (state.caseData) {
                if (!state.caseData.statuses) {
                    state.caseData.statuses = [];
                }
                const exstIndex = state.caseData.statuses.findIndex(x => x.systemStatus == action.payload.systemStatus && x.status == action.payload.status);
                if (exstIndex >= 0) {
                    state.caseData.statuses[exstIndex] = action.payload;
                } else {
                    state.caseData.statuses.push(action.payload);
                }
            }
        },     
        addExpenseTypeAction: (state, action: PayloadAction<string>) => {
            if (state.caseData) {
                if (!state.caseData.expenseTypes) {
                    state.caseData.expenseTypes = [];
                }
                // The signalR upsert can already contain the new type, so guard against duplicates
                if (!state.caseData.expenseTypes.includes(action.payload)) {
                    state.caseData.expenseTypes.push(action.payload);
                }
            }
        },
        deleteTypeAction: (state, action: PayloadAction<string>) => {
            if (state.caseData?.types) {
                state.caseData.types = state.caseData.types.filter((x) => x !== action.payload);
            }
        },
        deleteStatusAction: (state, action: PayloadAction<CaseStatus>) => {
            if (state.caseData?.statuses) {
                state.caseData.statuses = state.caseData.statuses.filter((x) => 
                    !(x.systemStatus == action.payload.systemStatus && x.status == action.payload.status)
                );
            }
        },
        deleteExpenseTypeAction: (state, action: PayloadAction<string>) => {
            if (state.caseData?.expenseTypes) {
                state.caseData.expenseTypes = state.caseData.expenseTypes.filter((x) => x !== action.payload);
            }
        },
    }
})

export const {
    setCaseDataAction,
    setCaseStatusesAction,
    addTypeAction,
    addStatusAction,
    addExpenseTypeAction,
    deleteTypeAction,
    deleteStatusAction,
    deleteExpenseTypeAction
} = caseDataSlice.actions;

export default caseDataSlice.reducer;